
import AppMobileFullScreenContainer from "@/components/common/MobileFullScreenContainer.vue";
import AppToolbar from "@/components/common/ToolbarBase.vue";
import { Product } from "@/models/base";
import { ProductService } from "@/services/product-service";
import Vue from "vue";
import AppTab2 from "./ProductInfoBuy.vue";
import AppTab1 from "./ProductInfoDefault.vue";
import AppTab4 from "./ProductInfoExtra.vue";
import AppTab3 from "./ProductInfoStock.vue";
import { UserConfigService } from "../../services/user-config-service";
import { DefaultEditTab, getVisibleDefaultEditTabs } from "@/utils/tabs/default-edit-tabs";
import { Permissions } from "@/models/user-configs/permissions";
import { DossierConfigService } from "@/services/dossier-config-service";
import AppExtraFieldTab from "@/components/ExtraFieldTab.vue";
import { ExtraFieldTabConfig } from "@/models/dossier-configs/extra-field-tab-config";
import { ExtraFieldNamesConfig } from "@/models/dossier-configs/extra-field-names-config";

export default Vue.extend({
	data() {
		return {
			tab: 0,
		};
	},
	props: {
		value: {
			type: Object as () => Product,
			required: true,
		},
		drawerButtonDisabled: Boolean
	},
	computed: {
		currentTab(): string {
			return this.tabs[this.tab];
		},
		showPurchaseDetails():boolean{
			return UserConfigService.hasCurrentUserPermission(p=>p.CanReadProductPurchaseDetails);
		},
		defaultTabs(): DefaultEditTab[] {
			let infoTabKeys = ["general", "buy", "stock", "extra-fields"];
			return getVisibleDefaultEditTabs(4, tab => {
				if (infoTabKeys.indexOf(tab.key) == -1) return false;
				return tab.key != "buy" || this.showPurchaseDetails;
			});
		},
		currentTabKey(): string {
			return this.defaultTabs[this.tab]?.key || "";
		},
		tabs(): string[] {
			let t = this.defaultTabs.map(tab => tab.key == "extra-fields" ? this.$ct("tabs.extra").toString() : tab.label());
			return [...t, ...this.extraFieldNamesConfig.getTabNames()];
		},
		extraFieldNamesConfig():ExtraFieldNamesConfig {
			return DossierConfigService.getExtraFieldNamesConfigs().ProductNames;
		},
		extraFieldTabs():ExtraFieldTabConfig[] {
			return this.extraFieldNamesConfig.getTabs();
		},
		product(): Product {
			return this.value;
		},
		titleKey():string {
			return "title-info";
		},
		hasPermission():boolean {
			return UserConfigService.hasCurrentUserPermission((permissions:Permissions):boolean=>{
				return permissions.ProductPermissions.hasWritePermissions();
			});
		}
	},
	methods: {
		trigger(value: string) {
			(this as any)[value]();
		},
		async cancel() {
			this.$emit("cancel");
		},
		edit(){
			this.$router.push(`/products/edit/${this.product.ID}`);
		},
		async remove() {
			let confirm = await this.$wf.confirm(this.$ct("confirm-delete"), this.$ct("common.yes"), this.$ct("common.no"), this.$ct("common.warning"), "warning");
			if (!confirm) return;
			await ProductService.delProducts([this.value]);
			this.$emit("delete");
		}
	},
	components: {
		AppTab1,
		AppTab2,
		AppTab3,
		AppTab4,
		AppToolbar,
		AppMobileFullScreenContainer,
		AppExtraFieldTab
	},
	i18nEx: {
		componentPrefix: "components.products"
	}
});
